import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../PrivacyStatement.css";

function PrivacyStatement() {
  return (
    <Container className="privacy-statement">
      <Row>
        <Col>
          <h1 className="text-center fw-bold my-4">
            Kişisel Verilerin Korunmasına İlişkin Aydınlatma Metni
          </h1>
          <h2>KolayCafe Tarafından İşlenen Kişisel Veriler</h2>
          <p>
            KolayCafe İşletmesi olarak; kişisel verilerinizin gizliliği ve
            güvenliği en önemli önceliklerimiz arasındadır. Bu kapsamda 6698
            sayılı Kişisel Verilerin Korunması Kanunu’nun (“KVKK”) 10.
            maddesinden doğan aydınlatma yükümlülüğümüzü yerine getirmek
            amacıyla kişisel verileriniz hakkında sizleri bilgilendirmek
            isteriz.
          </p>
          <p>
            Gizlilik Politikası, Kullanıcı ile akdedilen Kullanıcı
            Sözleşmesi’nin eki ve ayrılmaz bir parçası niteliğindedir. Şirket,
            belirtilen hedeflere yönelik verileri, Kullanıcı'nın ikamet ettiği
            ülke dışındaki herhangi bir coğrafi konumda bulunan sunucularına
            aktarma yetkisine sahiptir. Kullanıcı tarafından Site'ye yüklenen
            İçerik, tamamen Kullanıcıya aittir ve KolayCafe, bu İçeriği
            Kullanıcı onayını almadan açıklamayacak veya satmayacaktır.
          </p>
          <h2>
            Madde 1: KolayCafe Tarafından Hangi Kişisel Veriler İşlenmektedir?
          </h2>
          <p>
            KolayCafe platformunda yer alan üyelik koşullarını kabul ederek web
            sitesinden veya mobil cihazlara kurulan uygulamadan giriş yapan ve
            platformda yer alan ürünleri takip eden ve/veya satın alan kişiler
            “Üye” olarak tanımlanmaktadır. KolayCafe platformunda üye olmanız
            halinde aşağıdaki kişisel verileriniz işlenebilmektedir:
          </p>
          <ul>
            <li>Adınız, soyadınız, şirket bilgileriniz</li>
            <li>
              İletişim Bilgileriniz: cep telefonu numaranız, fatura adresiniz,
              e-posta adresiniz
            </li>
            <li>
              Fatura bilgileriniz, talep ve şikayet bilgileriniz, Intercom
              kanalıyla yapılan konuşma içerikleri
            </li>
            <li>
              İşlem Güvenliği Bilgileriniz: MAC adresi bilgisi, şifre ve parola
              bilgileri, çerez bilgileri
            </li>
            <li>
              İşitsel Kayıt Bilgileriniz: çağrı merkeziyle görüşmeniz halinde
              ses kaydınız
            </li>
            <li>Kullanılan cihazların GPS Konum bilgisi</li>
            <li>
              Sistemle ilgili teknik sorunların tanımlanması ve çözülmesi için
              IP adresi bilgisi
            </li>
            <li>Resim ve metin gibi siteye yüklenebilecek içerikler</li>
          </ul>
          <h2>
            Madde 2: Kişisel Verilerinizin İşlenmesinin Amaçları ve Toplama
            Yöntemleri
          </h2>
          <p>
            Kimlik, iletişim ve müşteri işlem bilgileriniz; sözleşmesel
            ilişkimiz kapsamında bizzat sizlerden, mobil uygulama ya da internet
            sitesinden elektronik ortamda otomatik olarak aşağıdaki amaçlarla
            toplanmakta ve işlenmektedir:
          </p>
          <ul>
            <li>
              Sözleşmenin kurulması ve ifasına yönelik süreçlerin yürütülmesi
            </li>
            <li>Finans ve muhasebe süreçlerinin yürütülmesi ve denetimi</li>
            <li>Şirketin iş faaliyetlerinin yürütülmesi ve denetimi</li>
            <li>Faturalandırma süreçlerinin yürütülmesi</li>
            <li>
              İnternet sitesi/mobil uygulamalar üzerinden satın alım
              işlemlerinin gerçekleşmesi
            </li>
            <li>
              Açık rızanızın bulunması halinde, pazarlama ve reklam
              faaliyetlerinde kullanılması
            </li>
          </ul>
          <h2>Madde 3: Kişisel Verilerinizin İşlenmesinin Hukuki Sebebi</h2>
          <p>
            KolayCafe, kişisel verilerinizi yukarıda yer alan amaçlarla ve
            KVKK’nın 5., 8. ve 9. maddelerinde belirtilen hukuka uygunluk
            sebeplerine dayanarak işlemektedir. Örneğin, 6563 sayılı Elektronik
            Ticaretin Düzenlenmesi Hakkında Kanun, 6102 Sayılı Türk Ticaret
            Kanunu ve 6502 sayılı Tüketicinin Korunması Hakkında Kanun başta
            olmak üzere mevzuattan kaynaklanan yükümlülüklerimizin yerine
            getirilmesi amacıyla kişisel verileriniz işlenebilir.
          </p>
          <h2>
            Madde 4: KolayCafe Kişisel Verilerinizi Kimlere Hangi Sebeplerle
            Aktarıyor?
          </h2>
          <p>
            Şirketimiz, kişisel verilerinizi “bilme gereği” ve “kullanma gereği”
            ilkelerine uygun olarak, gerekli veri minimizasyonunu sağlayarak ve
            gerekli teknik ve idari güvenlik tedbirlerini alarak işlemeye özen
            göstermektedir. İş faaliyetlerinin yürütülmesi veya denetimi, iş
            sürekliliğinin sağlanması, dijital altyapıların işletilmesi amacıyla
            işlediğimiz kişisel verileri belirli amaçlarla üçüncü kişilere
            aktarmak durumundayız.
          </p>
          <h2>Madde 5: Kişisel Verilerinizin Korunmasına Yönelik Haklarınız</h2>
          <p>
            Bu Aydınlatma Metni’nin “Hak ve Talepleriniz İçin İletişim”
            bölümünde yer alan yöntemlerle Şirketimize başvurarak, kişisel
            verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin
            bilgi talep etme gibi çeşitli haklara sahipsiniz.
          </p>
          <h2>Madde 6: Hak ve Talepleriniz İçin İletişim</h2>
          <p>
            Kişisel verilerinizle ilgili sorularınızı ve taleplerinizi,
            kolaycafe@gmail.com e-posta adresine iletebilirsiniz.
          </p>
          <h2>Madde 7: Aydınlatma Metni Hakkında</h2>
          <p>
            KolayCafe işbu Kişisel Verilerin Korunması Hakkında Açıklama metnini
            yürürlükteki mevzuatta yapılabilecek değişiklikler çerçevesinde her
            zaman güncelleme hakkını saklı tutar. Güncellenme Tarihi: 01/02/2024
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default PrivacyStatement;
